
import * as __star__ from 'react-router-dom';

const {

MemoryRouter,
Prompt,
Redirect,
Route,
Router,
StaticRouter,
Switch,
generatePath,
matchPath,
withRouter,
__RouterContext,
BrowserRouter,
HashRouter,
Link,
NavLink,
__esModule
} = __star__;

export {
MemoryRouter,
Prompt,
Redirect,
Route,
Router,
StaticRouter,
Switch,
generatePath,
matchPath,
withRouter,
__RouterContext,
BrowserRouter,
HashRouter,
Link,
NavLink,
__esModule
};

